import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LinkService } from '@core/services/link.service';
import { IButtonV2 } from '@core/types/button';
import { ArticlePageImports } from '@pages/articles/article-page/article-page.imports';
import { IProcessedContent } from '@pages/articles/interfaces/article.interface';
import { TArticleContentType } from '@pages/articles/types/article.type';
import { defaultBannerHeroInfo } from '@shared/banner-cta/banners-data.db';
import { IArticleBannerCTA } from '@shared/db/IBanner';
import { faqButton } from '@shared/faq-section/faq-section.db';

import { ArticlesDataService } from '../services/articles.data.service';

@Component({
  selector: 'noda-article-page',
  standalone: true,
  templateUrl: './article-page.component.html',
  styleUrls: ['./article-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: ArticlePageImports,
})
export class ArticlePageComponent {
  public articlesService: ArticlesDataService = inject(ArticlesDataService);
  private linkService: LinkService = inject(LinkService);

  private bannerInfoCTA: IArticleBannerCTA[] = this.articlesService.article()?.bannersCta;
  public bannerHeroCTA: IArticleBannerCTA =
    this.articlesService.article()?.bannerHeroCta || defaultBannerHeroInfo;
  public hasFAQ: boolean = Boolean(this.articlesService.article().faq.length);
  private parsedContent: string[];
  public readonly faqButton: IButtonV2 = faqButton;
  public processedContent: IProcessedContent[] = [];

  constructor() {
    this.processContent();
  }

  private processContent(): void {
    this.processedContent = this.content.map((contentPart: string) => {
      const bannerId: number = this.bannerId(contentPart);
      const contentType: TArticleContentType = bannerId ? 'banner' : 'default';

      return {
        contentPart,
        contentType,
        bannerInfo: bannerId ? this.getBannerInfo(bannerId) : null,
      };
    });
  }

  private get content(): string[] {
    if (!this.parsedContent) {
      this.parseContent(this.articlesService.article().content);
    }

    return this.parsedContent;
  }

  private parseContent(content: string): string[] {
    const bannerRegex: RegExp = /<div class="banner(\d+)"><\/div>/g;

    this.parsedContent = this.linkService
      .replaceLinkWithTag(content)
      .split(bannerRegex)
      .filter(Boolean);

    return this.parsedContent;
  }

  private bannerId(contentPart: number | string): number {
    return Number(contentPart);
  }

  private getBannerInfo(bannerId: number): IArticleBannerCTA | null {
    return this.bannerInfoCTA[bannerId - 1] || null;
  }
}
